import { useState, useEffect } from 'react';
import { firestore } from '../firebase';
import { collection, getDocs } from "firebase/firestore";

/** Firestore Timestamp → ms (fehlendes Datum = 0, erscheint unten) */
function createdAtToMillis(createdAt) {
  if (!createdAt) return 0;
  if (typeof createdAt.toMillis === 'function') return createdAt.toMillis();
  if (createdAt.seconds !== undefined) return createdAt.seconds * 1000;
  return 0;
}

export const useTemplateGallery = () => {
  const [templateImages, setTemplateImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTemplateImages = async () => {
      setIsLoading(true);
      try {
        const templatesCollectionRef = collection(firestore, 'templates');
        const querySnapshot = await getDocs(templatesCollectionRef);
        
        const fetchedTemplates = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.templateUrl) {
            fetchedTemplates.push({
              id: doc.id,
              url: data.templateUrl,
              thumbnailUrl: data.thumbnailUrl || data.templateUrl, // Use thumbnail if available, fallback to full image
              prompt: data.prompt || '',
              loadTemplateImage: data.loadTemplateImage || '',
              category: data.category || [],
              style: data.style || '',
              name: data.name || data.label || data.title || '',
              _sortMs: createdAtToMillis(data.createdAt),
            });
          }
        });

        fetchedTemplates.sort((a, b) => b._sortMs - a._sortMs);
        setTemplateImages(
          fetchedTemplates.map(({ _sortMs, ...rest }) => rest)
        );
      } catch (error) {
        console.error("Error fetching template images:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemplateImages();
  }, []);

  return { templateImages, isLoading };
};




